export const getScrollTop = () => {
  if (window.pageYOffset) return window.pageYOffset
  return document.documentElement.clientHeight
    ? document.documentElement.scrollTop
    : document.body.scrollTop
}

export const getViewportWidth = () => (
  Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
)

export const getViewportHeight = () => (
  Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
)

export const getDocumentHeight = () => {
  const body = document.body
  const html = document.documentElement
  
  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
}



// WEBPACK FOOTER //
// ./src/lib/util.js